module.exports = __webpack_public_path__ + "img/home_auth4.82403d14.png";